import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lookupValueTypePipe',
  standalone: true,
})
export class LookupValueTypePipePipe implements PipeTransform {
  transform(value: string | number,type: string | null): number | string | null {
    if (value == null ) return null;
    else if (type === 'number') return value.toString();
    else return value;
  }
}
